// extracted by mini-css-extract-plugin
export default {"container":"AllowTemplatesWarningModal_container__LKvur","buttons":"AllowTemplatesWarningModal_buttons__5Yy-i"};